import { ProductionLineHomePage } from '@/features/production-reporting';

const ProductionReporting = () => {
  return <ProductionLineHomePage />;
};

export default ProductionReporting;
